export function changeMainColorAction (mainColor) {
	return {
		type: 'CHANGE_MAIN_COLOR',
		payload: mainColor
	}
}